import { watchers as coreWatchers } from '@va/dashboard/sagas/shared';
import { all } from 'redux-saga/effects';
import * as ApiSaga from './api';
import * as AppSaga from './app';

export const watchersArr = [ApiSaga.watchers(), AppSaga.watchers(), ...coreWatchers];

export default function* rootSaga() {
  yield all(watchersArr);
}
